import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useClassName } from '../../../../hooks';
import { CollapsibleContext } from '../../Collapsible.context';
import './OpenContent.scss';
export const OpenContent = () => {
    const { isOpen, content, openContent } = useContext(CollapsibleContext);
    const className = useClassName({
        name: 'collapsible-open-content',
        prefixed: true,
    }, !!content && 'has-content');
    if (!isOpen && openContent)
        return null;
    return _jsx("div", { className: className, children: openContent });
};
